<template>
  <div>
    <app-time-row-edit
      @timeRowUpdated="updateTimeRow"
    ></app-time-row-edit>
  </div>
</template>

<script>
import TimeRowEdit from '../components/TimeRowEdit.vue';

export default {
  components: {
    'app-time-row-edit': TimeRowEdit,
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    updateTimeRow(newTimeRow) {
      console.log('newTimeRow: ', newTimeRow);
      this.$store.dispatch('updateTimeRow', newTimeRow)
        .then((response) => {
          if (response) {
            this.$router.push({ path: '/' });
          }
        });
    },
  },
};
</script>
